import { useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useAnalytics } from '@/hooks/useAnalytics'
import { ANALYTICS_EVENTS } from '@/analytics/analyticsEvents'

export default function QrRedirectPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { trackEvent } = useAnalytics()
  const { qrCode } = useParams<{ qrCode: string }>()

  useEffect(() => {
    const handleQrRedirect = async () => {
      // Determine the QR code identifier (from param or from path)
      const qrCodeIdentifier = qrCode || location.pathname.replace('/', '')
      
      // Track the QR code scan with campaign info
      await trackEvent(ANALYTICS_EVENTS.QR_CODE_SCANNED, {
        qr_code: qrCodeIdentifier,
        campaign: 'poster_helsinki',
        redirect_destination: '/feed?location=Helsinki',
        timestamp: Date.now()
      })

      // Redirect to feed page with Helsinki location
      navigate('/feed?location=Helsinki', { replace: true })
    }

    handleQrRedirect()
  }, [qrCode, location.pathname, trackEvent, navigate])

  // Show loading state while redirecting
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground mx-auto mb-4"></div>
        <p className="text-foreground">Redirecting...</p>
      </div>
    </div>
  )
}
